module.exports = __webpack_public_path__ + "img/missile-mech.ee9634da.svg";